<template>
  <div class="pd-about">
    <!-- Hero Section - Full Screen -->
    <section class="pd-hero">
      <div class="pd-hero-bg"></div>
      <div class="pd-hero-content">
        <div class="pd-hero-badge">EST. 2024</div>
        <h1 class="pd-hero-title">
          <span class="pd-title-line">POINT</span>
          <span class="pd-title-line pd-title-accent">OF</span>
          <span class="pd-title-line">DEMON</span>
        </h1>
        <p class="pd-hero-tagline">惡魔不是墮落，是覺醒</p>
        <div class="pd-scroll-indicator">
          <span>SCROLL</span>
          <div class="pd-scroll-line"></div>
        </div>
      </div>
    </section>

    <!-- Manifesto Section -->
    <section class="pd-manifesto">
      <div class="pd-container">
        <div class="pd-manifesto-content">
          <div class="pd-manifesto-number">01</div>
          <h2 class="pd-manifesto-title">我們的宣言</h2>
          <p class="pd-manifesto-text">
            當世界告訴你要循規蹈矩，<br>
            我們選擇打破一切規則。<br><br>
            Point of Demon 不只是一個品牌，<br>
            而是一場對平庸的反叛。<br><br>
            我們相信每個人內心都住著一個惡魔——<br>
            那個不願妥協、拒絕平凡的自己。
          </p>
        </div>
      </div>
    </section>

    <!-- Split Section - Philosophy -->
    <section class="pd-split">
      <div class="pd-split-image">
        <img src="https://images.unsplash.com/photo-1578632767115-351597cf2477?w=1200" alt="Dark Aesthetic" />
        <div class="pd-split-overlay"></div>
      </div>
      <div class="pd-split-content">
        <div class="pd-manifesto-number">02</div>
        <h2 class="pd-split-title">黑暗美學</h2>
        <p class="pd-split-text">
          黑色不是空虛，而是無限可能的起點。
        </p>
        <p class="pd-split-desc">
          我們擁抱黑暗，因為黑暗中才能看見真正的光芒。每一件作品都是對暗黑美學的極致詮釋——
          不需要繁複的裝飾，線條與輪廓本身就是最強烈的語言。
        </p>
      </div>
    </section>

    <!-- Values Section -->
    <section class="pd-values">
      <div class="pd-container">
        <div class="pd-values-header">
          <div class="pd-manifesto-number">03</div>
          <h2 class="pd-values-title">惡魔信條</h2>
        </div>
        <div class="pd-values-grid">
          <div class="pd-value-card">
            <div class="pd-value-icon">
              <span class="pd-icon-text">I</span>
            </div>
            <h3 class="pd-value-name">拒絕平庸</h3>
            <p class="pd-value-desc">
              我們不做大眾想要的，只做我們相信的。每一個設計都是對主流的挑戰。
            </p>
          </div>
          <div class="pd-value-card">
            <div class="pd-value-icon">
              <span class="pd-icon-text">II</span>
            </div>
            <h3 class="pd-value-name">極致品質</h3>
            <p class="pd-value-desc">
              惡魔也有原則。我們對品質的堅持，比任何人都更執著。
            </p>
          </div>
          <div class="pd-value-card">
            <div class="pd-value-icon">
              <span class="pd-icon-text">III</span>
            </div>
            <h3 class="pd-value-name">忠於自我</h3>
            <p class="pd-value-desc">
              穿上 Point of Demon，就是選擇做真正的自己。
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Quote Section -->
    <section class="pd-quote">
      <div class="pd-quote-bg"></div>
      <div class="pd-container">
        <blockquote class="pd-quote-text">
          "天使或許更受歡迎，<br>
          但惡魔從不無聊。"
        </blockquote>
        <cite class="pd-quote-author">— Point of Demon</cite>
      </div>
    </section>

    <!-- Final CTA -->
    <section class="pd-final-cta">
      <div class="pd-container">
        <h2 class="pd-cta-title">準備好覺醒了嗎？</h2>
        <p class="pd-cta-subtitle">加入我們，釋放你內心的惡魔</p>
        <router-link to="/products" class="pd-cta-btn">
          <span>探索系列</span>
          <i class="fas fa-arrow-right"></i>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'EcAbout',
  mounted () {
    // Add scroll animation
    this.observeElements()
  },
  methods: {
    observeElements () {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('pd-visible')
          }
        })
      }, { threshold: 0.1 })

      document.querySelectorAll('.pd-animate').forEach(el => {
        observer.observe(el)
      })
    }
  }
}
</script>

<style scoped>
/* Base */
.pd-about {
  background-color: #0a0a0a;
  color: #fff;
  overflow-x: hidden;
}

/* Hero Section */
.pd-hero {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.pd-hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background:
    radial-gradient(ellipse at 20% 80%, rgba(120, 0, 0, 0.15) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 20%, rgba(80, 0, 0, 0.1) 0%, transparent 50%),
    linear-gradient(180deg, #0a0a0a 0%, #111 50%, #0a0a0a 100%);
}

.pd-hero-bg::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E");
  opacity: 0.03;
}

.pd-hero-content {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 2rem;
}

.pd-hero-badge {
  font-family: 'MedievalSharp', cursive;
  font-size: 0.875rem;
  letter-spacing: 0.3em;
  color: #666;
  margin-bottom: 2rem;
}

.pd-hero-title {
  margin: 0;
}

.pd-title-line {
  display: block;
  font-family: 'Pirata One', 'UnifrakturMaguntia', cursive;
  font-size: clamp(3rem, 15vw, 10rem);
  font-weight: 400;
  letter-spacing: 0.05em;
  line-height: 0.9;
  text-transform: uppercase;
}

.pd-title-accent {
  font-family: 'MedievalSharp', cursive;
  font-size: clamp(1.5rem, 8vw, 5rem);
  font-weight: 400;
  letter-spacing: 0.5em;
  color: #8b0000;
  margin: 0.5rem 0;
}

.pd-hero-tagline {
  font-size: 1.125rem;
  font-weight: 300;
  letter-spacing: 0.2em;
  color: #888;
  margin-top: 3rem;
}

.pd-scroll-indicator {
  position: absolute;
  bottom: 3rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.pd-scroll-indicator span {
  font-family: 'MedievalSharp', cursive;
  font-size: 0.75rem;
  letter-spacing: 0.3em;
  color: #444;
}

.pd-scroll-line {
  width: 1px;
  height: 60px;
  background: linear-gradient(to bottom, #444, transparent);
  animation: scrollPulse 2s ease-in-out infinite;
}

@keyframes scrollPulse {
  0%, 100% { opacity: 1; transform: scaleY(1); }
  50% { opacity: 0.5; transform: scaleY(0.8); }
}

/* Manifesto Section */
.pd-manifesto {
  padding: 10rem 0;
  background: linear-gradient(180deg, #0a0a0a 0%, #111 100%);
}

.pd-manifesto-content {
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
}

.pd-manifesto-number {
  font-size: 0.75rem;
  letter-spacing: 0.3em;
  color: #8b0000;
  margin-bottom: 1.5rem;
}

.pd-manifesto-title {
  font-size: 2.5rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  margin-bottom: 3rem;
}

.pd-manifesto-text {
  font-size: 1.25rem;
  font-weight: 300;
  line-height: 2;
  color: #aaa;
}

/* Split Section */
.pd-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 100vh;
}

.pd-split-image {
  position: relative;
  overflow: hidden;
}

.pd-split-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(100%) contrast(1.1);
}

.pd-split-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent 0%, #0a0a0a 100%);
}

.pd-split-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4rem;
  background-color: #0a0a0a;
}

.pd-split-title {
  font-size: 3rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  margin-bottom: 1.5rem;
}

.pd-split-text {
  font-size: 1.5rem;
  font-weight: 300;
  color: #8b0000;
  margin-bottom: 2rem;
}

.pd-split-desc {
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.8;
  color: #888;
  max-width: 450px;
}

/* Values Section */
.pd-values {
  padding: 10rem 0;
  background:
    radial-gradient(ellipse at 50% 0%, rgba(120, 0, 0, 0.08) 0%, transparent 50%),
    #0a0a0a;
}

.pd-values-header {
  text-align: center;
  margin-bottom: 5rem;
}

.pd-values-title {
  font-size: 2.5rem;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.pd-values-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.pd-value-card {
  text-align: center;
  padding: 3rem 2rem;
  border: 1px solid #222;
  background: linear-gradient(180deg, #111 0%, #0a0a0a 100%);
  transition: all 0.4s ease;
}

.pd-value-card:hover {
  border-color: #8b0000;
  transform: translateY(-8px);
}

.pd-value-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 2rem;
  border: 1px solid #333;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s ease;
}

.pd-value-card:hover .pd-value-icon {
  border-color: #8b0000;
  background-color: rgba(139, 0, 0, 0.1);
}

.pd-icon-text {
  font-family: 'UnifrakturMaguntia', cursive;
  font-size: 1.75rem;
  font-weight: 400;
  letter-spacing: 0.05em;
  color: #666;
  transition: color 0.4s ease;
}

.pd-value-card:hover .pd-icon-text {
  color: #8b0000;
}

.pd-value-name {
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  margin-bottom: 1rem;
}

.pd-value-desc {
  font-size: 0.875rem;
  font-weight: 300;
  line-height: 1.8;
  color: #666;
}

/* Quote Section */
.pd-quote {
  position: relative;
  padding: 10rem 0;
  text-align: center;
  overflow: hidden;
}

.pd-quote-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background:
    radial-gradient(ellipse at center, rgba(139, 0, 0, 0.15) 0%, transparent 70%),
    #0a0a0a;
}

.pd-quote-text {
  position: relative;
  z-index: 1;
  font-size: clamp(1.5rem, 4vw, 3rem);
  font-weight: 300;
  font-style: italic;
  line-height: 1.6;
  letter-spacing: 0.05em;
  margin: 0;
  padding: 0 2rem;
}

.pd-quote-author {
  position: relative;
  z-index: 1;
  display: block;
  margin-top: 3rem;
  font-family: 'Pirata One', cursive;
  font-size: 1.125rem;
  font-style: normal;
  letter-spacing: 0.15em;
  color: #666;
}

/* Final CTA */
.pd-final-cta {
  padding: 10rem 0;
  text-align: center;
  background: linear-gradient(180deg, #0a0a0a 0%, #111 50%, #0a0a0a 100%);
}

.pd-cta-title {
  font-size: clamp(2rem, 5vw, 3.5rem);
  font-weight: 700;
  letter-spacing: 0.05em;
  margin-bottom: 1rem;
}

.pd-cta-subtitle {
  font-size: 1.125rem;
  font-weight: 300;
  color: #666;
  margin-bottom: 3rem;
}

.pd-cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 3rem;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: #fff;
  background-color: #8b0000;
  border: none;
  text-decoration: none;
  transition: all 0.4s ease;
}

.pd-cta-btn:hover {
  background-color: #a00;
  transform: translateX(8px);
}

.pd-cta-btn i {
  transition: transform 0.4s ease;
}

.pd-cta-btn:hover i {
  transform: translateX(4px);
}

/* Container */
.pd-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* Responsive */
@media (max-width: 1024px) {
  .pd-split {
    grid-template-columns: 1fr;
  }

  .pd-split-image {
    height: 50vh;
  }

  .pd-split-overlay {
    background: linear-gradient(180deg, transparent 0%, #0a0a0a 100%);
  }

  .pd-values-grid {
    grid-template-columns: 1fr;
    max-width: 500px;
  }
}

@media (max-width: 768px) {
  .pd-manifesto {
    padding: 6rem 0;
  }

  .pd-manifesto-title {
    font-size: 2rem;
  }

  .pd-manifesto-text {
    font-size: 1rem;
  }

  .pd-split-content {
    padding: 3rem 2rem;
  }

  .pd-split-title {
    font-size: 2rem;
  }

  .pd-split-text {
    font-size: 1.125rem;
  }

  .pd-values {
    padding: 6rem 0;
  }

  .pd-values-title {
    font-size: 2rem;
  }

  .pd-quote {
    padding: 6rem 0;
  }

  .pd-final-cta {
    padding: 6rem 0;
  }

  .pd-scroll-indicator {
    display: none;
  }
}

@media (max-width: 480px) {
  .pd-hero-tagline {
    font-size: 0.875rem;
  }

  .pd-value-card {
    padding: 2rem 1.5rem;
  }
}
</style>
